// extracted by mini-css-extract-plugin
module.exports = {"welcome__subline":"_2309q","welcome__headline":"_2Isl7"};